"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var gsap_1 = __importDefault(require("gsap"));
var ScrollTrigger_1 = require("gsap/dist/ScrollTrigger");
var react_1 = require("react");
var use_breakpoints_1 = __importDefault(require("../use-breakpoints"));
function useAnimation(init, deps, breakpoints) {
    if (deps === void 0) { deps = []; }
    (0, react_1.useEffect)(function () {
        gsap_1.default.registerPlugin(ScrollTrigger_1.ScrollTrigger);
    }, []);
    var _a = (0, use_breakpoints_1.default)(), xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, current = _a.current;
    (0, react_1.useEffect)(function () {
        if (init &&
            (!breakpoints ||
                ((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.includes("xs")) && xs) ||
                ((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.includes("sm")) && sm) ||
                ((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.includes("md")) && md) ||
                ((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.includes("lg")) && lg) ||
                ((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.includes("xl")) && xl))) {
            var animations_1 = init();
            return function () {
                animations_1 === null || animations_1 === void 0 ? void 0 : animations_1.forEach(function (animation) { return animation.kill(); });
            };
        }
        return undefined;
    }, __spreadArray(__spreadArray([], deps, true), [current], false));
    return {
        gsap: gsap_1.default,
        ScrollTrigger: ScrollTrigger_1.ScrollTrigger,
    };
}
exports.default = useAnimation;
//# sourceMappingURL=index.js.map